<template>
    
</template>
<script>
export default {
    created(){
        window.location.href = "https://share.hsforms.com/1KYEWzIYQR_eBHtVQqlBUxA1tcm2";
    }
}
</script>